<template>
  <v-app >
    <v-main class="mainApp" >

      <!-- TODO component scroll button -->
      <v-scale-transition origin="center center">
        <v-btn
          class="scrollButton"
          position: fixed
          color="primary"
          fab
          transition="scale-transition"
          @click="$vuetify.goTo(0, { duration: 500 })"
          v-show="returnButton"
        >
          <v-icon> mdi-chevron-up </v-icon>
        </v-btn>
      </v-scale-transition>

      <SearchQuery @runSearch="runSearch" @sendToKawnime="runSendToKawnime"/>

      <PicsResult 
        v-if="foundData"
        class="spaceTop"
        @runSearch="runSearch" 
        @openDetails="openDetails($event)" 
      />

      <div v-else class="spaceTop notFound">
        <img src="@/assets/tohru3.png" alt="no results" class="notFound__img"/>
        <div class="pa-8">
         <span>Sorry, no results...</span>
        </div>
      </div>
  
      <DetailsModal 
        v-if="dialog"
        :dialog="dialog"
        @closeDetails="closeDetails()"
        @runSearch="runSearch" 
      />

      <!-- Infinity Scroll -->
      <ObserverIntersect
        v-if="alreadyRanSearch && this.isLoading === false"
        @intersect="loadMorePics"
      />      
      
      <v-progress-linear
        v-show="isLoadingMore"
        class="progressBarLoadinMore"
        color="blue accent-4"
        indeterminate
        rounded
        height="10"
      />

      <v-overlay v-show="isLoading">
        <v-progress-circular
          :width="6"
          indeterminate
          size="80"
        ></v-progress-circular>
      </v-overlay>
    </v-main>
  </v-app>
</template>

<script>
import SearchQuery from "@/components/SearchQuery";
import PicsResult from "@/components/PicsResult";
import ObserverIntersect from "@/components/ObserverIntersect";
import { mapState, mapActions, mapGetters } from "vuex";
import connectTarget from "@/mixins/connectTarget";
import DetailsModal from './components/DetailsModal.vue';

export default {
  name: "App",

  components: {
    SearchQuery,
    PicsResult,
    ObserverIntersect,
    DetailsModal
  },

  data: () => {
    return {
      foundData: true,
      isLoading: false,
      isLoadingMore: false,
      alreadyRanSearch: false,
      textSearch: "",
      page: 1,
      returnButton: false,  
      dialog: false,
      picturesDetails: {}
    };
  },

  mixins: [connectTarget],

  computed:{
    ...mapGetters('listPictures', ['listPictureslength']),
    ...mapGetters('admin', ['getPermission']),
    ...mapState('listPictures', ['listPictures'])
  },

  methods: {
    ...mapActions("listPictures", ["clearListPictures", "uncheckAll"]),
    

    async runSearch(textSearch) {
      this.textSearch = textSearch;
      this.page = 1;
      this.isLoading = true;

      this.clearListPictures();

      await this.handleConnectTarget(this.textSearch, this.page, this.getPermission);

      this.alreadyRanSearch = true;
      this.isLoading = false;

      if (this.listPictureslength && this.listPictureslength > 0) {
        this.foundData = true
      } else {
        this.foundData = false;
      }
      
    },

    async loadMorePics() {
      if (this.isLoadingMore) return;

      this.isLoadingMore = true;

      this.page++;
      await this.handleConnectTarget(this.textSearch, this.page, this.getPermission);

      this.isLoadingMore = false;
    },

    async runSendToKawnime(listChecked) {
      await this.handleSendToKawanime(listChecked)
      this.uncheckAll()
    },

    openDetails(){
      this.dialog = true
    },

    closeDetails(){
      this.dialog = false
    }
  },
  
  created () {
    document.title = '✨ Kawanime Search Pics'

    // need to be with arrowFunction cuz its a promisse to update data()
    window.addEventListener("scroll", () => {
      if(window.scrollY == 0){
        this.returnButton = false
      } else {
        this.returnButton = true
      }
    });
  },

  destroyed () {
    try {
      window.removeEventListener('scroll');
    } catch(error) {
      if (error) throw error
    }
  },

};
</script>


<style>
.mainApp {
  background: radial-gradient(
    ellipse at center,
    hsl(162, 50%, 26%),
    transparent
  );
  background-color: #111927;
}

.spaceTop {
  margin-top: 80px;
}

.notFound {
  display: flex;
  color: white;
  font-size: 20px;
  align-items: center;
  flex-direction: column;
}

.notFound__img {
  filter: drop-shadow(8px 8px 5px black)
}

.scrollButton {
  position: fixed;
  right: 5px;
  bottom: 5px;
  z-index: 2; 
}

.progressBarLoadinMore {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 500px;
  left: 50%;
  transform: translate(-50%);
}

@media (max-width: 600px) {
  .progressBarLoadinMore {
    width: 300px;
  }
}

.loader {
  width: 32px;
  height: 32px;
  border: 5px solid #fff;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  animation: pulse 1s linear infinite;
}
.loader:after {
  content: '';
  position: absolute;
  width: 32px;
  height: 32px;
  border: 5px solid #fff;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: scaleUp 1s linear infinite;
}

@keyframes scaleUp {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  60%,
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
@keyframes pulse {
  0%,
  60%,
  100% {
    transform: scale(1);
  }
  80% {
    transform: scale(1.2);
  }
}
</style>
